export const editingLocked = (data, id) =>
  data.some((item) => item.type === id);
